import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import WaferField from "@/components/WaferField";

const HERO_IMG = "/img/original.jpg";
const HERO_VIDEO = "/video/hero.mp4";

export default function Hero() {
    return (
        <section className="relative flex min-h-screen items-center overflow-hidden bg-roast">
            {/* Full-screen background video — fills the entire screen */}
            <video
                className="absolute inset-0 z-0 h-full w-full object-cover"
                src={HERO_VIDEO}
                poster={HERO_IMG}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                data-testid="hero-video"
            />
            {/* Readability overlays */}
            <div className="absolute inset-0 z-[2] bg-gradient-to-r from-roast/90 via-roast/45 to-roast/10" />
            <div className="absolute inset-0 z-[2] bg-gradient-to-t from-roast/70 via-transparent to-roast/30" />

            <WaferField />

            <div className="relative z-10 mx-auto w-full max-w-7xl px-5 lg:px-8">
                <div className="max-w-2xl">
                    <span className="sp-anim-in inline-flex items-center gap-2 rounded-full bg-cream-50/15 px-4 py-1.5 text-sm font-medium text-banana backdrop-blur-sm ring-1 ring-cream-50/20">
                        <Sparkles size={15} /> Handcrafted fresh · Small batch
                    </span>

                    <h1 className="sp-anim-in mt-5 font-serif text-4xl font-semibold leading-[1.05] tracking-tight text-cream-50 sm:text-5xl lg:text-6xl">
                        Taste the <span className="italic text-banana">Pearl</span> of Every Sweet Moment
                    </h1>

                    <p className="sp-anim-in mt-5 max-w-xl text-base leading-relaxed text-cream-100/85 sm:text-lg">
                        Rich, creamy, handcrafted banana pudding made to turn every spoonful into something special.
                    </p>

                    <div className="sp-anim-in mt-8 flex flex-wrap gap-4">
                        <Link
                            to="/shop"
                            data-testid="hero-shop-btn"
                            className="group inline-flex items-center gap-2 rounded-full bg-banana px-7 py-3.5 text-base font-semibold text-roast shadow-pill transition-all hover:bg-banana-hover active:scale-95"
                        >
                            Shop Puddings
                            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
                        </Link>
                        <Link
                            to="/shop"
                            data-testid="hero-flavors-btn"
                            className="inline-flex items-center gap-2 rounded-full border border-cream-50/40 bg-cream-50/5 px-7 py-3.5 text-base font-semibold text-cream-50 backdrop-blur-sm transition-all hover:bg-cream-50/15 active:scale-95"
                        >
                            Explore Our Flavors
                        </Link>
                    </div>

                    <div className="sp-anim-in mt-10 flex flex-wrap items-center gap-6 text-sm text-cream-100/80">
                        <span>⭐ 4.9 · 1,500+ reviews</span>
                        <span className="hidden sm:inline">•</span>
                        <span>Pickup · Local Delivery · Shipping</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
